export default {
    dataDimension: true,
}
